export default {
    SET_CONTACT_LIST(state, contacts) {
        state.contactList = contacts
    },
    SET_CONTACT_LIST_CONDITIONS(state, contacts) {
        state.contactListConditions = contacts
    },
}